import { Capacitor, registerPlugin } from "@capacitor/core";

const DocumentExport = registerPlugin("DocumentExport");

function asBase64(blob) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = () => reject(new Error("The export couldn't be prepared."));
    reader.onload = () => resolve(String(reader.result).split(",")[1]);
    reader.readAsDataURL(blob);
  });
}

// Android WebView does not implement browser blob downloads. Let the user
// choose a local document and wait for native writing to finish instead.
export async function saveExportFile(blob, filename) {
  if (Capacitor.getPlatform() === "android") {
    const result = await DocumentExport.save({
      filename,
      mimeType: blob.type || "application/octet-stream",
      base64: await asBase64(blob),
    });
    if (result?.cancelled) return { cancelled: true };
    if (result?.saved !== true) throw new Error("The export was not saved.");
    return { saved: true };
  }

  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  try {
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
  } finally {
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
  }
  // Browsers don't confirm that a download was written to disk.
  return { saved: false };
}
